import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import LoginPage from './component/loginPage';
import EditPad from './component/editPage';
import EditPadTop from './component/editPageTop'
import EditPadLeft from './component/editPageLeft'
import FileSearch from './component/fileComponet/fileSearch'
import * as serviceWorker from './serviceWorker';

import {Router,hashHistory,Route,IndexRoute} from 'react-router';

ReactDOM.render((
    <Router history={hashHistory}>
        <Route path='/' component={LoginPage}></Route>
        <Route path='/editPage' component={EditPad}>
            {/*<Route path='/editPageTop' component={EditPadTop}/>*/}
            {/*<Route path='/editPageLeft' component={EditPadLeft}/>*/}
            {/*<Route path='/filePage' component={FileSearch}/>*/}
        </Route>
    </Router>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
